module.exports = __webpack_public_path__ + "static/media/KaryaTalents_logo.9d3bb143.svg";